// src/components/DynamicInfo.js
import React, { useState, useEffect, useRef } from 'react';
import './DynamicInfo.css'; 

// Import images
import image1 from '../images/image1.png';
import image2 from '../images/image2.png';
import image3 from '../images/image3.png';
import image4 from '../images/image4.png';

const DynamicInfo = () => {
  const [activeIndex, setActiveIndex] = useState(0); 
  const [isVisible, setIsVisible] = useState(false); 
  const containerRef = useRef(null); 

  const data = [
    {
      title: 'Welcome Note',
      content: `The African Association of Veterinary Education Establishments (2A2E-V) is proud to announce the 2nd Annual VetEd Africa conference. 
      
      Building on the resounding success of the 2022 VetEd Africa conference held in South Africa, this joint initiative will take place in Rabat, Morocco, from November 19 to 21, 2026. The conference aims to foster global excellence in veterinary education by bringing together veterinary educators to build a community of practice. 
      
      This year's focus is specifically tailored to address a crucial need identified by 2A2E-V: The benefits of Artificial Intelligence (AI) in veterinary education, exploring its application and impact. We anticipate welcoming 80-120 participants, including delegates from all five regions of Africa, international CIVME attendees, and faculty members from local Moroccan institutions. We look forward to advancing, harmonizing, and disseminating best practices in veterinary medical education together.`,
      image: image1,
    },
    {
      title: 'About Rabat',
      content: `Rabat, the capital of Morocco and a UNESCO World Heritage site, combines tradition and modernity. A coastal city on the Atlantic, it is famous for its iconic monuments such as the Hassan Tower, the Kasbah of the Udayas, and the Mohammed V Mausoleum. A major cultural and educational center, Rabat is home to renowned institutions. Thanks to its modern infrastructure and international openness, Rabat is an ideal location for scientific and professional events.`,
      image: image3,
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true); 
          }
        });
      },
      { threshold: 0.1 } 
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  // Function to handle accordion toggling
  const toggleAccordion = (index) => {
    // If the clicked item is already active, close it by setting activeIndex to null
    // Otherwise, open the clicked item
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div
      className={`dynamic-info-container ${isVisible ? 'visible' : ''}`}
      ref={containerRef}
    >
      {/* Image Section */}
      <div className="image-container">
        <img
          // Default to the first image if all accordions are closed
          src={activeIndex !== null ? data[activeIndex].image : data[0].image}
          alt={activeIndex !== null ? data[activeIndex].title : data[0].title}
          className="dynamic-image"
        />
      </div>

      {/* Information Section */}
      <div className="info-container">
        {data.map((item, index) => (
          <div key={index} className="info-button-container">
            {/* Button */}
            <button
              className={`info-button ${index === activeIndex ? 'active' : ''}`}
              onClick={() => toggleAccordion(index)} 
            >
              {item.title}
              <span className="toggle-icon">{index === activeIndex ? '−' : '+'}</span>
            </button>

            {/* Content below the button (visible only when active) */}
            {index === activeIndex && (
              <div className="info-content">
                {/* Use dangerouslySetInnerHTML or split by newline to render paragraphs properly */}
                {item.content.split('\n').map((paragraph, i) => (
                  <p key={i}>{paragraph}</p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DynamicInfo;